module.exports = __webpack_public_path__ + "static/media/moistrol-2.f07a0f50.jpg";